export const SUGGEST_PROMPT_TYPES = {
  improve: 'improve_prompt',
  personalize: 'personalize_prompt',
};
